import React from 'react';
import { Link } from 'react-router-dom';

function Footer( props ) {
    const { container = "container" } = props;

    return (
        <footer className="footer">
            <div className="footer-middle" style={{'marginLeft':'20%'}}>
                <div className={ container }>
                    <div className="row">
                        <div className="col-sm-12 col-lg-5">
                            <div className="widget widget-about">
                                <img src={ `${process.env.REACT_APP_PUBLIC_URL}/assets/images/logo11and11.png` } className="footer-logo" alt="Footer Logo" width="105" height="25" />
                            
                                <div className="widget-about-info">
                                    <div className="row">
                                        <div className="col-sm-6 col-md-4">
                                            <span className="widget-about-title">Vous avez une question?</span>

                                            <span className="widget-about-title">Appelez-nous de 08H00 à 18H00</span>
                                            <a href="tel:+212 6 00 66 17 99"><span>06 00 66 17 99</span></a>
                                        </div>
                                        <div className="col-sm-6 col-md-8">
                                            {/*<span className="widget-about-title">Mode de paiement</span>*/}
                                            <figure className="footer-payments">
                                                {/*<img src={ `${process.env.REACT_APP_PUBLIC_URL}/assets/images/payments.png` } alt="Payment methods" width="272" height="20" />*/}
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4 col-lg-2">
                            <div className="widget">
                                <h4 className="widget-title">Contactez-Nous</h4>

                                <ul className="widget-list">
                                    <li><Link to={ `${process.env.REACT_APP_PUBLIC_URL}/pages/faq` }>FAQ</Link></li>
                                    <li><Link to={ `${process.env.REACT_APP_PUBLIC_URL}/pages/contact` }>Contacts</Link></li>
                                    <li><Link to={ `${process.env.REACT_APP_PUBLIC_URL}/pages/about` }>À propos</Link></li>
                                    {/*<li><Link to="#">Terms and conditions</Link></li>
                                    <li><Link to="#">Privacy Policy</Link></li>*/}
                                </ul>
                            </div>
                        </div>

                        
                        <div className="col-sm-4 col-lg-2">
                            <div className="widget">
                                <h4 className="widget-title">Mon compte</h4>

                                <ul className="widget-list">
                                    <li><Link to={ `${process.env.REACT_APP_PUBLIC_URL}/pages/login` }>Se Connecter</Link></li>
                                    <li><Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/cart` }>Liste de souhaits</Link></li>
                                    <li><Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/wishlist` }>Panier</Link></li>
                                    {/*<li><Link to="#">Track My Order</Link></li>
                                    <li><Link to="#">Help</Link></li>*/}
                                </ul>
                            </div>
                        </div>

                        {/*<div className="col-sm-6 col-lg-2">
                            <div className="widget widget-newsletter">
                                <h4 className="widget-title">Les Nouvelles</h4>

                                <p>Abonnez-vous pour obtenir des informations sur les produits et les coupons.</p>

                                <form action="#">
                                    <div className="input-group">
                                        <input type="email" className="form-control" placeholder="Enter your Email Address" aria-label="Email Adress" required />
                                        <div className="input-group-append">
                                            <button className="btn btn-dark" type="submit"><i className="icon-long-arrow-right"></i></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                                </div>*/}
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className={ container }>
                    <p className="footer-copyright">Copyright © { ( new Date() ).getFullYear() } <a href="https://www.fcpo.ma" target="_blank">FCPO</a>. All Rights Reserved.</p>

                    <div className="social-icons social-icons-color">
                        <span className="social-label">Suivez-nous sur les réseaux sociaux</span>
                        <a href="https://www.facebook.com" className="social-icon social-facebook" rel="noopener noreferrer" title="Facebook" target="_blank"><i className="icon-facebook-f"></i></a>
                        <a href="https://twitter.com" className="social-icon social-twitter" rel="noopener noreferrer" title="Twitter" target="_blank"><i className="icon-twitter"></i></a>
                        <a href="https://instagram.com" className="social-icon social-instagram" rel="noopener noreferrer" title="Instagram" target="_blank"><i className="icon-instagram"></i></a>
                        <a href="https://youtube.com" className="social-icon social-youtube" rel="noopener noreferrer" title="Youtube" target="_blank"><i className="icon-youtube"></i></a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default React.memo( Footer );